import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Pencil } from "lucide-react";
import { Modal, Field, inputCls, Btn, ConfirmDialog, AdminImageUpload } from "./kit";

const EMPTY = { name: "", province: "", region: "", altitude: "", coffee_type: "", processing: "", supplier_info: "", description: "", image: "", order: 0 };

export default function AdminOrigins() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [confirm, setConfirm] = useState(null);

  const load = async () => { try { const r = await api.get("/admin/origins"); setItems(r.data); } catch (e) {} };
  useEffect(() => { load(); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.name) { toast.error("Name required"); return; }
    try {
      const payload = { ...form, order: parseInt(form.order) || 0 };
      if (editing) await api.put(`/admin/origins/${editing}`, payload); else await api.post("/admin/origins", payload);
      toast.success("Saved"); setModal(false); load();
    } catch (e) { toast.error("Failed"); }
  };
  const del = async () => { try { await api.delete(`/admin/origins/${confirm}`); toast.success("Deleted"); setConfirm(null); load(); } catch (e) { toast.error("Failed"); } };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <div><h1 className="font-display text-2xl font-extrabold text-offwhite">Coffee Origins</h1><p className="mt-1 font-body text-sm text-offwhite/55">Add confirmed sourcing regions.</p></div>
        <Btn onClick={() => { setForm(EMPTY); setEditing(null); setModal(true); }} data-testid="add-origin-btn"><Plus className="mr-1 inline h-4 w-4" /> Add Origin</Btn>
      </div>
      {items.length === 0 ? <div className="rounded-xl border border-dashed border-offwhite/15 py-16 text-center font-body text-sm text-offwhite/40">No origins added.</div> : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((o) => (
            <div key={o.id} className="rounded-xl border border-offwhite/10 bg-[#101c14] p-4">
              {o.image && <img src={o.image} alt={o.name} className="mb-3 aspect-[4/3] w-full rounded-lg object-cover" />}
              <div className="flex items-start justify-between">
                <div><div className="font-display text-base font-bold text-offwhite">{o.name}</div><div className="font-mono text-[10px] uppercase text-amber-soft">{[o.province, o.region].filter(Boolean).join(" · ")}</div></div>
                <div className="flex gap-1">
                  <button onClick={() => { setForm({ ...EMPTY, ...o }); setEditing(o.id); setModal(true); }} className="rounded p-1.5 text-offwhite/70 hover:bg-offwhite/10"><Pencil className="h-4 w-4" /></button>
                  <button onClick={() => setConfirm(o.id)} className="rounded p-1.5 text-rose-300 hover:bg-rose-500/10"><Trash2 className="h-4 w-4" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <Modal open={modal} onClose={() => setModal(false)} title={editing ? "Edit Origin" : "Add Origin"} wide>
        <div className="max-h-[68vh] space-y-4 overflow-y-auto pr-1">
          <AdminImageUpload value={form.image} onChange={(v) => set("image", v)} testId="origin-image-upload" />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <Field label="Origin Name *"><input data-testid="origin-name" className={inputCls} value={form.name} onChange={(e) => set("name", e.target.value)} /></Field>
            <Field label="Province"><input className={inputCls} value={form.province} onChange={(e) => set("province", e.target.value)} /></Field>
            <Field label="Region"><input className={inputCls} value={form.region} onChange={(e) => set("region", e.target.value)} /></Field>
            <Field label="Altitude"><input className={inputCls} value={form.altitude} onChange={(e) => set("altitude", e.target.value)} /></Field>
            <Field label="Coffee Type"><input className={inputCls} value={form.coffee_type} onChange={(e) => set("coffee_type", e.target.value)} /></Field>
            <Field label="Processing"><input className={inputCls} value={form.processing} onChange={(e) => set("processing", e.target.value)} /></Field>
          </div>
          <Field label="Farmer / Supplier Information"><input className={inputCls} value={form.supplier_info} onChange={(e) => set("supplier_info", e.target.value)} /></Field>
          <Field label="Description"><textarea rows={3} className={inputCls} value={form.description} onChange={(e) => set("description", e.target.value)} /></Field>
          <div className="flex justify-end gap-3"><Btn variant="ghost" onClick={() => setModal(false)}>Cancel</Btn><Btn onClick={save} data-testid="save-origin-btn">Save</Btn></div>
        </div>
      </Modal>
      <ConfirmDialog open={!!confirm} onClose={() => setConfirm(null)} onConfirm={del} message="Delete this origin?" />
    </div>
  );
}
